// This file is auto-generated by backend/internal/scripts/generate-stripe-ts.go. Do not edit directly.
// This was last generated at 2026-07-01 06:43:16 PDT

export interface StripePlanFeature {
	name: string;
}

export interface StripePlanPrice {
	id: string; // Stripe Price ID
	amount: number; // Price in cents
	interval: "month" | "year";
}

export interface StripePlan {
	productId: string; // Stripe Product ID
	name: string; // e.g., "Personal", "Team", "Enterprise"
	description: string;
	features: StripePlanFeature[];
	monthlyPrice: StripePlanPrice;
	yearlyPrice: StripePlanPrice;
}

export const stripePlans: StripePlan[] = [
	{
		productId: "prod_S91Wv6zmAMns00",
		name: "Personal",
		description: "Get going with API access, audit logs, and notifications",
		features: [
			{ name: "Email support" },
			{ name: "5,000 API requests / month" },
			{ name: "30 day audit log retention" },
			{ name: "Up to 3 team seats" },
			{ name: "Notifications & usage alerts" },
		],
		monthlyPrice: {
			id: "price_1REjUOQ0vZLOhAhoF7id00XR",
			amount: 999,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1REjUOQ0vZLOhAhow8F2sgZw",
			amount: 9999,
			interval: "year",
		},
	},
	{
		productId: "prod_S91WmwYxOAcH8M",
		name: "Team",
		description: "Scale with sub-accounts and higher API limits",
		features: [
			{ name: "Email support" },
			{ name: "10,000 API requests / month" },
			{ name: "45 day audit log retention" },
			{ name: "Unlimited team seats" },
			{ name: "Up to 5 sub-accounts" },
			{ name: "API usage threshold alerts" },
		],
		monthlyPrice: {
			id: "price_1REjUOQ0vZLOhAhoroNLqPQQ",
			amount: 2999,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1REjUPQ0vZLOhAhoqBjgTNnN",
			amount: 29999,
			interval: "year",
		},
	},
	{
		productId: "prod_S91WxMIJftK6Cz",
		name: "Enterprise",
		description:
			"Run your fleet with unlimited sub-accounts and priority support",
		features: [
			{ name: "Priority support" },
			{ name: "25,000 API requests / month" },
			{ name: "90 day audit log retention" },
			{ name: "Unlimited team seats" },
			{ name: "Unlimited sub-accounts" },
			{ name: "API usage threshold alerts" },
		],
		monthlyPrice: {
			id: "price_1REjUPQ0vZLOhAhoKLuigLOg",
			amount: 9999,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1REjUQQ0vZLOhAhoWU8YcZi5",
			amount: 99999,
			interval: "year",
		},
	},
];

// Helper function to find a plan by its product ID
export function getPlanByProductId(productId: string): StripePlan | undefined {
	return stripePlans.find((plan) => plan.productId === productId);
}

// Helper function to find a plan by its name (case-insensitive)
export function getPlanByName(name: string): StripePlan | undefined {
	const lowerCaseName = name.toLowerCase();
	return stripePlans.find((plan) => plan.name.toLowerCase() === lowerCaseName);
}

// Helper function to get the price object based on interval
export function getPriceByInterval(
	plan: StripePlan,
	interval: "month" | "year",
): StripePlanPrice {
	return interval === "month" ? plan.monthlyPrice : plan.yearlyPrice;
}

export interface StripeApiAddon {
	queries: number;
	label: string;
	monthlyPrice: StripePlanPrice;
	yearlyPrice: StripePlanPrice;
}

export const stripeApiAddons: StripeApiAddon[] = [
	{
		queries: 5000,
		label: "+5K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPDQ0vZLOhAhoThsuDl8p",
			amount: 1000,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPEQ0vZLOhAho5BJcmbYs",
			amount: 10000,
			interval: "year",
		},
	},
	{
		queries: 10000,
		label: "+10K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPEQ0vZLOhAhodiPJw5hu",
			amount: 1800,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPEQ0vZLOhAhoSSzGTFOp",
			amount: 18000,
			interval: "year",
		},
	},
	{
		queries: 25000,
		label: "+25K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPFQ0vZLOhAhoGAXfSdLJ",
			amount: 4000,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPFQ0vZLOhAho49JeCsyJ",
			amount: 40000,
			interval: "year",
		},
	},
	{
		queries: 50000,
		label: "+50K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPGQ0vZLOhAhoK2GDP32h",
			amount: 7500,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPGQ0vZLOhAhofIVpQd2X",
			amount: 75000,
			interval: "year",
		},
	},
	{
		queries: 100000,
		label: "+100K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPGQ0vZLOhAhooqNDamo6",
			amount: 14000,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPHQ0vZLOhAhozyHhyOyK",
			amount: 140000,
			interval: "year",
		},
	},
	{
		queries: 250000,
		label: "+250K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPHQ0vZLOhAhoa5I7HpqO",
			amount: 30000,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPIQ0vZLOhAhoaGI1Jerg",
			amount: 300000,
			interval: "year",
		},
	},
	{
		queries: 500000,
		label: "+500K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPIQ0vZLOhAho88CWgQnl",
			amount: 55000,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPIQ0vZLOhAhoGKg1e6Uf",
			amount: 550000,
			interval: "year",
		},
	},
	{
		queries: 750000,
		label: "+750K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPJQ0vZLOhAhoHMb4WW09",
			amount: 75000,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPJQ0vZLOhAhoS7XJNsjO",
			amount: 750000,
			interval: "year",
		},
	},
	{
		queries: 975000,
		label: "+975K queries/mo",
		monthlyPrice: {
			id: "price_1ToOPKQ0vZLOhAhow1bFDdjF",
			amount: 90000,
			interval: "month",
		},
		yearlyPrice: {
			id: "price_1ToOPKQ0vZLOhAhoAGES0Llo",
			amount: 900000,
			interval: "year",
		},
	},
];
